export default __webpack_public_path__ + "static/media/1-1735134524532.402edfdc.png";